/**
 * @author yan st
 * @date 2026-07-24
 * @Description: 管理端-绩效管理、月报管理模块API
 */
import { qspost } from "@/plugins/axiosAdmin";

/*
 *   获取项目列表
 * */
export const adminGetProjectList = (data) =>
  qspost("/admin/NewModule/getProjectList", data);

/*
 *   获取项目详情
 * */
export const adminGetProjectDetail = (project_id) =>
  qspost("/admin/NewModule/getProjectDetail", { project_id });

/*
 *   获取指标分类列表
 * */
export const adminGetRuleClassList = (project_id) =>
  qspost("/admin/NewModule/getRuleClassList", { project_id });

/*
 *   按分类获取指标
 * */
export const adminGetRuleListByClass = (project_id, class_id) =>
  qspost("/admin/NewModule/getRuleListByClass", { project_id, class_id });

/*
 *   保存指标
 * */
export const adminSaveRule = (data) =>
  qspost("/admin/NewModule/saveRule", data);

/*
 *   删除指标
 * */
export const adminDeleteRule = (rule_id) =>
  qspost("/admin/NewModule/deleteRule", { rule_id });

/*
 *   获取指标列表（按分类）
 * */
export const adminGetRuleList = (project_id) =>
  qspost("/admin/NewModule/getRuleList", { project_id });

/*
 *   获取填报历史
 * */
export const adminGetRuleRecordList = (rule_id) =>
  qspost("/admin/NewModule/getRuleRecordList", { rule_id });

/*
 *   保存/编辑分类
 * */
export const adminSaveRuleClass = (data) =>
  qspost("/admin/NewModule/saveRuleClass", data);

/*
 *   删除分类
 * */
export const adminDeleteRuleClass = (class_id) =>
  qspost("/admin/NewModule/deleteRuleClass", { class_id });

/*
 *   获取月报列表
 * */
export const adminGetReportList = (data) =>
  qspost("/admin/NewModule/getReportList", data);

/*
 *   审核月报
 * */
export const adminApproveReport = (data) =>
  qspost("/admin/NewModule/approveReport", data);

/*
 *   审核绩效填报记录
 * */
export const adminApproveRuleRecord = (data) =>
  qspost("/admin/NewModule/approveRuleRecord", data);

export const adminDeleteContractFile = (project_id, file_index) =>
  qspost("/admin/NewModule/deleteContractFile", { project_id, file_index });
